import Vue from 'vue'
export default {
  updateArrayState(state, payload) {
    if (payload.index !== -1) {
      //Vue.set(state[payload.prop], payload.index, payload.value)
      state[payload.prop].splice(payload.index, 1, payload.value)
    }
  },
  updateArrayStateByValue(state, payload) {
    //console.log(payload);
    var index = state[payload.prop].indexOf(payload.value);
    //console.log(index);
    if (index !== -1) {
      Vue.set(state[payload.prop], index, payload.editedValue)
      //state[payload.prop].splice(index, 1, payload.editedValue)
    }
  },
  updateArrayStateById(state, payload) {
    //console.log(payload);  
    var index = state[payload.prop].indexOf(state[payload.prop].filter(obj => {
      return obj.id == payload.editedValue.id;
    })[0])
    if (index !== -1) {
      //console.log(`${payload.prop} array object updated`);   
      Vue.set(state[payload.prop], index, payload.editedValue)
    }
  },
  setState(state, payload) {
    //console.log(payload.prop + " state set")
    state[payload.prop] = payload.value;
  },
  addToArrayState(state, payload) {
    var i = state[payload.prop].findIndex(item => {
      return payload.value.id == item.id
    })
    if (i < 0) {
      //console.log(payload.prop + " state value added");
      state[payload.prop].unshift(payload.value);
    }

  },
  addToArrayStatePush(state, payload) {
    //console.log(payload.prop + " state value added");
    state[payload.prop].push(payload.value);
  },
  deleteFromArrayState(state, payload) {
    //console.log(payload.prop + " state value deleted");
    state[payload.prop].splice(payload.index, 1);
  },
  deleteFromArrayStateByValue(state, payload) {
    var index = state[payload.prop].indexOf(payload.value);
    //console.log(index);
    if (index !== -1) {
      //console.log(payload.prop + " state value deleted");
      state[payload.prop].splice(index, 1);
    }
  },
  deleteFromArrayStateById(state, payload) {
    //console.log(payload);
    var index = state[payload.prop].indexOf(state[payload.prop].filter(obj => {
      return obj.id == payload.id;
    })[0])
    if (index !== -1) {
      //console.log(`${payload.prop} array object deleted`);
      state[payload.prop].splice(index, 1);
    }
  },
  replaceInArrayState(state, payload) {
    //console.log(payload.prop + " state value reset");
    state[payload.prop] = [];
  }
}